import { api } from '../api';

export default function CalendarExport() {
  const handleExport = () => {
    window.open(api.calendarExportUrl(), '_blank');
  };

  return (
    <div className="space-y-1.5">
      <button
        onClick={handleExport}
        className="bg-brand-ink/10 hover:bg-white/15 text-brand-ink/80 rounded-lg px-3 py-2 text-sm font-semibold transition-all"
        title="Export trip to calendar"
      >
        Add to Calendar
      </button>
      <div className="text-[11px] text-brand-ink/55">
        Download .ics file &mdash; works with Google Calendar, Apple Calendar, Outlook
      </div>
    </div>
  );
}
